import Header from '../components/Header/HeaderBanner'
import Footer from '../components/Footer'
import { StyleUtil } from '../utils/StyleUtil'
import { useDataContext } from '../context/DataProvider'
import { goToTop } from '../utils/interactions'
import { isProduction } from '../utils/EnvUtils'
import { Assessment } from '../apis/entities/assessment.entity'
import heroBanner from '../images/hero-banner.png'

export default function DoneBefore() {
  const {
    candidateId,
    incrementProgress,
    startTest,
    setStep,
    assessment,
    adjustLevel,
    postSubmissionStart,
  } = useDataContext()

  const handleSubmitClick = async () => {
    // console.log('candidateId', candidateId)
    postSubmissionStart(candidateId, !isProduction)
    startTest()
    incrementProgress()
    goToTop()
    if (((assessment as Assessment)?.classifiedLevels.length ?? 0) > 0) {
      setStep(1)
    } else {
      adjustLevel()
      setStep(2)
    }
  }

  return (
    <div className="h-screen flex flex-col items-center">
      <div className="relative lg:max-w-[1000px] xl:max-w-[1200px] w-full h-full flex flex-col">
        <div className="bg-white grow">
          <div className="relative md:max-w-[800px] lg:max-w-[1000px] xl:max-w-[1200px] w-full mx-auto">
            <Header media={heroBanner} title={assessment?.title ?? ''} />
            <h1 className="text-4xl font-bold pt-6 px-1">
              Thanks for completing the test!
            </h1>
            <div className="font-roboto pt-6 px-1">
              <p className="">You have already completed this test.</p>
            </div>

            {!isProduction && (
              <div className="flex justify-center pt-6">
                <button
                  data-testid="btn-begin-test"
                  className={StyleUtil.buttonWhiteToYellow}
                  onClick={handleSubmitClick}
                >
                  Begin test (This button only appears in local and dev
                  environments)
                </button>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}
